/**
 * Are the portal login settings (Reliance / National / KSHEMA user name, password, login URL) shown to this login?
 *
 * SHOW_USER_CRETENTIAL_UBDATE (the backend .env, served as `showUserCredentialUpdate`) applies to the `user` role ONLY: a
 * `user` sees the settings while it is on and not at all while it is off. Every other login (client / admin, accountant,
 * operator, branch manager, ...) always sees them, whatever the switch says.
 */
export const credentialSettingsShown = (switchOn, userType = sessionStorage.getItem("userType")) =>
  userType !== "user" || switchOn === true;
